import React from "react";
import { useDrop } from "react-dnd";
import "./Basket.css";
import basketImg from "../assets/basket.png";

const emojiMap = {
  apple: "🍎",
  orange: "🍊",
  banana: "🍌",
  strawberry: "🍓",
};

const Basket = ({ basket, onDropFruit, onRemove }) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "FRUIT",
    drop: (item) => onDropFruit(item.name),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={drop}
      className="basket"
      style={{
        background: isOver ? "#d1f7d1" : "#fff",
        padding: "15px",
        borderRadius: "12px",
        marginTop: "20px",
        transition: "0.3s",
        textAlign: "center",
        minWidth: "240px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h3>Your Basket</h3>
      <ul
        className="basket-list"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        {Object.entries(basket).map(([fruit, count]) =>
          count > 0 ? (
            <li
              key={fruit}
              style={{
                fontSize: "1.8rem",
                fontWeight: "bold",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <span>
                {emojiMap[fruit]} x {count}
              </span>
              <button
                onClick={() => onRemove(fruit)}
                style={{
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "20px", // smaller width
                  height: "20px", // smaller height
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "16px", // smaller font size
                  lineHeight: "18px",
                  marginLeft: "8px", // space between text and button
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                aria-label={`Remove one ${fruit}`}
                title={`Remove one ${fruit}`}
              >
                −
              </button>
            </li>
          ) : null
        )}
      </ul>

      <div className="basket-image-wrapper" style={{ marginTop: "10px" }}>
        <img src={basketImg} alt="Basket" className="basket-image" />
      </div>
    </div>
  );
};

export default Basket;
